module.exports = __webpack_public_path__ + "img/nibianqi.40c2ef34.png";